import axios from '@/libraries/axios/authentication';

import User from '@/models/User';

export async function login(payload: {
  username: string | null;
  password: string | null;
}): Promise<{}> {
  const response = await axios.post('/login_check', payload);

  return response.data;
}

export async function authenticate(payload: string): Promise<{token: string, user: User} | null> {
  const response = await axios.get('/security/authentication/' + payload);

  return response.data;
}
